import { PAGE_ITSELF, RecordByPrimaryKey, makeGrowEntry } from "#public"

export const MiscGrowList = RecordByPrimaryKey([
  makeGrowEntry(
    "r1",
    "ROUNDED_CORNERS",
    "TEMPLATE",
    PAGE_ITSELF,
    { is_single_page: true, show_cut: false },
    { svg_round_corner_size: 10 }
  ),
  makeGrowEntry(
    "r2",
    "OVAL",
    "TEMPLATE",
    PAGE_ITSELF,
    { is_single_page: true, show_cut: false, show_security: false },
    { svg_round_corner_size: 5000000 }
  ),
  // Hang tags: a shape and the hole it hangs from (see CreateExtraShapes)
  makeGrowEntry(
    "r1h",
    "ROUNDED_CORNERS_HOLE",
    "TEMPLATE",
    PAGE_ITSELF,
    { is_single_page: true, show_cut: false },
    { svg_round_corner_size: 10 }
  ),
  makeGrowEntry(
    "r2h",
    "OVAL_HOLE",
    "TEMPLATE",
    PAGE_ITSELF,
    { is_single_page: true, show_cut: false, show_security: false },
    { svg_round_corner_size: 5000000 }
  ),
  makeGrowEntry("tgh", "TAG_HOLE", "TEMPLATE", PAGE_ITSELF, {
    is_single_page: true,
    show_cut: false,
  }),
] as const)
